<template>
    <section>
        <o-tabs type="boxed" position="left">
            <o-tab-item label="Pictures" icon="images" />
            <o-tab-item label="Music" icon="music" />
            <o-tab-item label="Words" />
            <o-tab-item label="Videos" icon="video" />
        </o-tabs>

        <o-tabs type="boxed" position="centered">
            <o-tab-item label="Pictures" icon="images" />
            <o-tab-item label="Music" icon="music" />
            <o-tab-item label="Words" />
            <o-tab-item label="Videos" icon="video" />
        </o-tabs>

        <o-tabs type="boxed" position="right">
            <o-tab-item label="Pictures" icon="images" />
            <o-tab-item label="Music" icon="music" />
            <o-tab-item label="Words" />
            <o-tab-item label="Videos" icon="video" />
        </o-tabs>
    </section>
</template>
